var hostname = typeof window !== "undefined" &&  window && window.location && window.location.hostname;
var siteUrl = '';
if(hostname){
  siteUrl = window.location.origin;
}

if(siteUrl === ''){
  console.log('Not configured');
  siteUrl = 'http://payvibe.com';
}

var appConfig = {
  
// dev mode to mock async data for instance
  DEV_MODE: false,
  // When you need some kind "console spam" to debug
  DEBUG_ENABLED: true,
  // fake delay to mock async
  FAKE_ASYNC_DELAY: 1000,

  appName: 'DDB Site Panel',
  helloWord: 'Hello',
  currentView: 'home',

  // connection status text references
  connectionStatus: {
    online: 'online',
    disconnected: 'disconnected'
  },
  // eaningGraph config
  earningGraph: {
    data: {
      API: 'api/earnigGraphData'
    }
  },
  teamMates:{
    data: {
      API: 'api/teamMates'
    }
  },

  // userInfos config
  userInfos: {
    data: {
      // API: 'http://192.168.1.15:8081/v1/login'
      // API: 'api/userInfos'
    }
  },

  app:{
    port: '3023',
    ip: '0.0.0.0'
  },
  site: {
    siteId: '5fa5d2e95e57bb17f40fa62b5e95aada',
    secret_key: '0RvyXOymzXXMQi5GLjlQnfBH37Urs2LC9N7xIfDT',
    siteurl :siteUrl
  },

  api: {
    // url: 'http://ddb-api.dealopia.com/v1/',
    url: 'https://api.payvibe.com/v1/',
  }  
};

module.exports = appConfig;




// WEBPACK FOOTER //
// ./appConfig.js